/*
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-08-25 19:55:44
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-09-14 10:42:01
 */
const vuex_newFuncsViewed = JSON.parse(localStorage.getItem('vuex_newFuncsViewed') || '[]');
export default {
	vuex_loading: null, // 全屏loading对象
	vuex_system_conf: {}, // 系统配置参数  热度云/诺特兰德
	// vuex_commission_rules: {},
	vuex_newFuncsViewed, // 存储点击了红点的功能
	vuex_platformId: '',
};
